import {
  queryOptions,
  useMutation,
  UseMutationOptions,
  useQueries,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import { Clinic } from 'lib/documents/clinic';
import {
  clinicGetAllInfo,
  clinicInfoEdit,
  getClinicBasicInfo
} from 'lib/api/firebase/apis/apis';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

/**
 * Get basic clinic information
 * @param clinicId
 * @returns
 */
export function params_useGetBasicClinicInfo(clinicId: string) {
  return queryOptions({
    queryKey: queryKeyFactory.clinic.basicInfo(clinicId),
    queryFn: () => getClinicBasicInfo(clinicId).then(_ => _.data)
  });
}
export function useGetBasicClinicInfo(clinicId: string) {
  return useQuery(params_useGetBasicClinicInfo(clinicId));
}

export function useGetClinicAllInfo(clinicId: string) {
  const query = useQuery({
    queryKey: queryKeyFactory.clinic.allInfo(clinicId),
    queryFn: () => clinicGetAllInfo(clinicId).then(_ => _.data),
    enabled: !!clinicId
  });

  return {
    clinicInfo: query.data ?? null,
    refreshClinicInfo: query.refetch,
    query
  };
}

export function useMutateClinicInfo(
  extraOptions?: Omit<
    UseMutationOptions<unknown, unknown, Clinic>,
    'mutationFn'
  >
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...extraOptions,
    mutationFn: (clinic: Clinic) => clinicInfoEdit(clinic).then(_ => _.data),
    async onSuccess(_data, variables, context) {
      await extraOptions?.onSuccess?.(_data, variables, context);

      queryClient.invalidateQueries({
        queryKey: queryKeyFactory.clinic.__root__(variables.id)
      });
    }
  });
}

export function useGetClinicInfoMultiple(clinics: string[]) {
  const queries = useQueries({
    queries: (clinics ?? []).map(clinicId =>
      params_useGetBasicClinicInfo(clinicId)
    )
  });

  return queries;
}
